<template>
  <div class="container" style="max-width: 100%;">
    <div class="xuanke_box">
      <h1 class="titleh1">在线论文答辩等待区</h1>
    </div>
    <div class="area">
      <div class="area-left">
        <div class="area-infos">
          <div v-for="(e, i) in infoList" :key="i" class="info message_info">
            <div v-if="e.messageType==1||e.messageType==2||e.messageType==3">
              <img src="@/assets/images/ai_ai.png" alt="" />
              系统通知
              <span style="font-size:12px;color:#79BBFF;margin-left:15px">{{e.time |formatDate}}</span>
            </div>
            <div v-if="e.messageType==4">
              <template v-if="e.isTeacher">
                <img src="@/assets/images/teacher.jpeg" alt="" />
                考核老师
              </template>
              <template v-else>
                <img src="@/assets/images/sduty.jpg" alt="" />
                <!-- {{e.speakerName |nmm}} -->
                {{e.speakerName }}
              </template>
              <span style="font-size:12px;color:#79BBFF;margin-left:15px">{{e.time |formatDate}}</span>
            </div>
            <div class="infoContext">
              {{ e.content }}
            </div>
          </div>
        </div>
        <div class="sendinfo">
          <el-input type="textarea" :rows="4" placeholder="" v-model="content" @keydown.enter.native.prevent="send">
          </el-input>
          <div class="btns">
            <el-button type="primary" size="mini" @click="send" :loading="sendloading">发送</el-button>
            <el-button type="danger" size="mini" @click="toDb"
              >开始答辩</el-button
            >
          </div>
        </div>
      </div>
      <div class="area-right">
        <div class="tip">
          <h3>
            您前方还有
            <span style="font-size: 30px; color: #409eff">{{info.befor_no}}</span>
            位同学
          </h3>
          <div>请提前做好准备</div>
        </div>

        <div class="studyInfo">
          <h4>当前考生</h4>
          <div class="infoBg">
            <div>学生：{{user.name}}（{{user.idCardNumber}}）</div>
            <div>专业：<span v-if="user.specialtyCode">{{user.specialtyCode}}-{{user.specialtyName}}</span></div>
            <div>课程：<span v-if="query.courseCode">{{query.courseCode}}-{{query.courseName}}</span></div>
            <div>序号：{{info.group_no}}</div>
          </div>
        </div>

        <el-table
          :data="dbList"
          ref="dbListTable"
          height="calc(100% - 340px)"
          border
          style="width: calc(100% - 4px); margin: 10px 2px 0"
          :row-class-name="tableRowClassName"
        >
          <el-table-column :label="`答辩名单（${dbList.length}人）`">
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                {{ scope.row.stuName  }}
              </template>
            </el-table-column>
            <el-table-column prop="groupNo" label="序号">
            <template #default="scope">
              {{ scope.row.groupNo }}
              
              <i class="el-icon-bottom"  style="cursor: pointer;color:#F56C6C" v-if="+scope.row.isDelayed>0" @click="clearDelayed(scope.row)"></i>
            </template>
             </el-table-column>
            <el-table-column prop="address" label="状态" min-width="110px">
              <template slot-scope="scope">
                <span v-if="scope.row.isOnline" style="color:#67C23A">在线</span>
                <span v-else style="color:#F56C6C">离线</span>
                ({{ scope.row.status?'已答辩':'未答辩' }})
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "",
  data() {
    return {
      infoList: [],
      dbList: [],
      info:{},
      content: "",
      thesisId: "",
      sendloading:false,
      groupId:'',
      query:{}
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.thesisId = this.$route.query.thesisId;
    this.groupId = this.$route.query.groupId;
    this.query = this.$route.query
    this.getInfo();
    this.$websocket.initWebSocket(this.thesisId, this.user.id,this.groupId); //初始化ws
    window.addEventListener("onmessageWS", this.getSocketData); //监听ws消息
  },
  methods: {
    getInfo() {
      this.$http
        .post_s("/student/thesis2/user/dbStatusList", this.$route.query,{isQs:1})
        .then(res => {
          this.info=res||{}
          this.dbList=res.db_list||[]
          // const current=this.dbList.find(e=>e.groupNo==this.info.be_defending_group_no)
          // if(current){
          //   this.$refs.dbListTable.setCurrentRow(current);
          // }
        });
    },
    send() {
      const _t=this
      if(!this.content){
        this.$message.error('请输入消息内容！')
        return
      }
      this.sendloading=true
      const data = {
        messageType: 4,
        speakerId: this.user.id,
        speakerName: this.user.name,
        content: this.content,
        isTeacher: 0,
      };
      this.$http
        .post(`/student/thesis2/${this.groupId}/sendMsg`, data,{isQs:1})
        .then(res => {
         this.content=''
        }).finally(()=>{
        this.sendloading=false
      })
      // this.$websocket.sendWebsocket(data).then(res=>{
      //   this.content=''
      // }).catch(req=>{
      //   this.$message.error(req)
      // }).finally(()=>{
      //   this.sendloading=false
      // })
    },
    toDb() {
      const _t = this;
      this.$http
        .post("/student/thesis2/user/enterOnlineReply", this.$route.query,{isQs:1})
        .then(res => {
          const { href } = _t.$router.resolve({
            path: "/online-defense-room",
            query: res,
          });
          window.open(href, "_blank");
        });
    },
    getSocketData(res) {
      const _t=this
      const data=res.detail
      const t=data.messageType
      if(t==1||t==2||t==3||t==4){
        //有新消息
        this.infoListPush(data)
      }
      if(t==3&&data.nextUserId==_t.user.id){
        //叫号通知
         this.$alert(`请${_t.user.name}（身份证号：${_t.user.idCardNumber}，序号：${_t.info.group_no}）立即进入答辩！`, '通知', {
          confirmButtonText: '确定',
          callback: action => {
            if(action=='confirm'){
              _t.toDb()
            }
          }
        });
      }
      if(t==1||t==2||t==3||t==5||t==6){
        //刷新学生列表
        this.getInfo();
      }
    },
    infoListPush(data){
      this.infoList.push(data)
        this.$nextTick(()=>{
         const infoDom= document.getElementsByClassName('message_info')[document.getElementsByClassName('message_info').length-1]
         const infoDomHeight=getComputedStyle(infoDom).getPropertyValue("height")
         const infoBk=document.getElementsByClassName('area-infos')[0]
         const height=+ infoDomHeight.replace('px','')
         infoBk.scrollTop += height+10;
        })
    },
    tableRowClassName({row, rowIndex}) {
        // if (row.groupNo==this.info.be_defending_group_no) {
        //   return 'success-row';
        // }
      }
  },
  destroyed() {
    this.$websocket.close(); //断开连接
  },
};
</script>
<style >
.el-table .success-row {
    background: #f0f9eb;
  }
</style>
<style scoped lang="scss">
.container{
  height: 100%;
  width: 100%;
}
.area {
  display: flex;
  height: calc(100% - 57px);
  .area-left {
    width: 100%;
    position: relative;
    background: #f6f7f9;
    .area-infos {
      padding: 10px;
      height: calc(100% - 100px);
      overflow: auto;
      .info {
        margin-bottom: 10px;
        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 5px;
        }
        .infoContext {
          background: #fff;
          border-radius: 5px;
          padding: 5px;
          margin: 5px 0 0 28px;
          display: inline-block;
        }
      }
    }
    .sendinfo {
      display: flex;
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #e9ecf3;
      .btns {
        width: 100px;
        text-align: center;
        padding: 10px;
        .el-button {
          margin: 5px 0;
          width: 100%;
        }
      }
    }
  }
  .area-right {
    width: 300px;
    min-width: 300px;
    background: #fff;

    .tip {
      text-align: center;
      padding: 30px 0;
      border-bottom: 1px solid #e9ecf3;
    }
    .studyInfo {
      padding: 15px 2px 0 5px;
      color: #409eff;
      h4 {
        // color: #409eff;
      }
      .infoBg {
        margin-top: 10px;
        background: #f2f7fe;
        padding: 10px;
        border-radius: 5px;
        div {
          margin: 5px 0;
        }
      }
    }
  }
}
</style>
